import React,{useState,useEffect} from 'react'
import './index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPrint, faSearch, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const Index = ({List, currentPage, totalPages, totalRecords, onPageChange}) => {
  const [filterList,setfilterList] = useState(List);
  const [searchText,setSearchText] = useState("");

  function filterFunction(value){
    setSearchText(value);
    if(value === ""){
      setfilterList(List);
    }
    else{
      const filtedList = List.filter((obj)=>{
        return Object.values(obj)
        .join(" ").toLowerCase()
        .includes(value.toLowerCase());
      })
      setfilterList(filtedList);
    }
  }
  useEffect(()=>{
      setfilterList(List);
      setSearchText("");
  },[List])
  return (
    <div className='user_table_wrapper'>
      <div className='user_table_search'>
        <input value={searchText} onChange={(e)=>{filterFunction(e.target.value);}}/>
        <div className='user_table_search_icon'>
          <FontAwesomeIcon icon={faSearch}/>
        </div>
      </div>
      <div className='user_table_container'>
        <div className='_table'>
          <div className='_thead'>
            <div className='_tr'>
              <div className='_th' style={{width:"10%"}}>Invoice</div>
              <div className='_th' style={{width:"30%"}}>Client</div>
              <div className='_th' style={{width:"15%"}}>Status</div>
              <div className='_th' style={{width:"15%"}}>Department</div>
              <div className='_th' style={{width:"15%"}}>Date</div>
              <div className='_th' style={{width:"15%",textAlign:"end"}}>Net Total</div>
            </div>
          </div>
          <div className='_tbody'>
            {filterList.length > 0 &&
              filterList.map((item,index)=>{
                return(
                  <div className='_tr' style={{padding:"5px 0px"}} key={index}>
                    <div className='_td' style={{width:"10%"}}>OR{item.id}</div>
                    <div className='_td' style={{width:"30%"}}>{item.doctorname}</div>
                    <div className='_td' style={{width:"15%"}}>{item.statusname}</div>
                    <div className='_td' style={{width:"15%"}}>{item.departmentname}</div>
                    <div className='_td' style={{width:"15%", backgroundColor:item.ordercolor}}>
                      {item.duedate.split('',10)}
                    </div>
                    <div className='_td' style={{width:"15%",textAlign:"end"}}>{item.nettotal}</div>
                  </div>
                )
              })
            }
            {filterList.length <= 0 &&
              <div className='table_nodata'>
                <p>No data available</p>
              </div>
            }
          </div>
        </div>
      </div>
      {totalPages > 1 &&
        <div className='pagination_controls'>
          <button
            className='pagination_btn'
            onClick={()=> onPageChange(currentPage - 1)}
            disabled={currentPage <= 1}
          >
            <FontAwesomeIcon icon={faChevronLeft}/> Previous
          </button>
          <span className='pagination_info'>Page {currentPage} of {totalPages} ({totalRecords} records)</span>
          <button
            className='pagination_btn'
            onClick={()=> onPageChange(currentPage + 1)}
            disabled={currentPage >= totalPages}
          >
            Next <FontAwesomeIcon icon={faChevronRight}/>
          </button>
        </div>
      }
    </div>
  )
}

export default Index
